import React from 'react';
import TextFilter from 'components/list/Filters/types/TextFilter';

const TitleFilter = <TextFilter
    label='resources.products.fields.title'
    options={ {
        floatingLabelFixed: true,
        fullWidth: true,
    } }
    source='title'
/>;

export default TitleFilter;



// WEBPACK FOOTER //
// ./src/components/form/filters/TitleFilter.js